<template>
    <AppLayout
        page="/dashboard"
        pageTitle="Transactions"
        backLink="/dashboard/reports"
    >
        <v-overlay :value="retryLoading" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-col cols="12" class="pa-1">
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="soli-subtitle"
                                    >{{
                                        `${globalMomentMonthFull(
                                            rangeStart
                                        )} ${globalMomentYear(rangeStart)}`
                                    }} </v-list-item-title
                                ><v-list-item-title
                                    >Monthly breakdown of processing fees, sales
                                    tax, and uncollectible
                                    invoices</v-list-item-title
                                >
                                <v-list-item-subtitle
                                    style="white-space: normal"
                                    >{{
                                        allLocations
                                            ? "Transactions By Location"
                                            : selectedLocation.name
                                    }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle
                                    class="font-bold py-1"
                                    style="white-space: normal"
                                    ><v-btn
                                        v-if="can('View admin reports')"
                                        x-small
                                        outlined
                                        class="soli-round soli-blue-text"
                                        @click="range(0, !allLocations)"
                                        >{{
                                            allLocations
                                                ? `View ${selectedLocation.name}`
                                                : `View All Locations`
                                        }}</v-btn
                                    >
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-row>
                                    <v-menu
                                        left
                                        offset-y
                                        max-width="250"
                                        :close-on-content-click="false"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                :small="$vuetify.breakpoint.xs"
                                                icon
                                                class="elevation-3 mr-4"
                                            >
                                                <v-badge
                                                    color="accent"
                                                    overlap
                                                    bordered
                                                    dot
                                                    :value="search"
                                                >
                                                    <v-icon
                                                        class="soli-blue-text text-shadow-blue"
                                                        >tune</v-icon
                                                    >
                                                </v-badge></v-btn
                                            >
                                        </template>
                                        <v-list
                                            ><v-list-item>
                                                <v-text-field
                                                    v-model="search"
                                                    label="Filter"
                                                    single-line
                                                    outlined
                                                    dense
                                                    clearable
                                                    :append-icon="
                                                        search ? null : 'tune'
                                                    "
                                                    hide-details
                                                ></v-text-field></v-list-item
                                            ><v-list-item v-if="allLocations"
                                                ><v-select
                                                    label="Group By"
                                                    dense
                                                    outlined
                                                    item-text="display"
                                                    item-value="value"
                                                    @input="setGroupBy($event)"
                                                    v-model="groupBy"
                                                    :items="[
                                                        {
                                                            display:
                                                                'Total Transactions',
                                                            value: null,
                                                        },
                                                        {
                                                            display: 'Location',
                                                            value: 'location',
                                                        },
                                                        {
                                                            display: 'Date',
                                                            value: 'date',
                                                        },
                                                    ]"
                                                    return-object
                                                    hide-details
                                                ></v-select></v-list-item></v-list
                                    ></v-menu>
                                </v-row>
                            </v-list-item-action>
                            <v-list-item-action
                                ><v-row>
                                    <v-btn
                                        :small="$vuetify.breakpoint.xs"
                                        icon
                                        class="elevation-3"
                                        @click="range(-1, allLocations)"
                                        ><v-icon color="dark"
                                            >chevron_left</v-icon
                                        ></v-btn
                                    >
                                    <v-btn
                                        :small="$vuetify.breakpoint.xs"
                                        icon
                                        class="elevation-3 ml-1"
                                        @click="range(1, allLocations)"
                                        ><v-icon color="dark"
                                            >chevron_right</v-icon
                                        ></v-btn
                                    >
                                    <v-text-field
                                        v-if="false"
                                        v-model="search"
                                        style="width: 200px"
                                        class="pl-6"
                                        append-icon="filter_list"
                                        label="Filter"
                                        single-line
                                        hide-details
                                    ></v-text-field
                                ></v-row>
                            </v-list-item-action> </v-list-item
                    ></v-list>
                    <v-data-table
                        v-if="
                            allLocations && !byLocation && transactions.length
                        "
                        :headers="headers"
                        :items="transactions"
                        disable-pagination
                        hide-default-footer
                        mobile-breakpoint="0"
                        :search="search"
                    >
                        <template v-slot:[`location`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ item.location }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`total`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ item.total }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                    </v-data-table>
                    <v-data-table
                        v-if="
                            (!allLocations || byLocation) && transactions.length
                        "
                        :headers="headers"
                        :items="transactions"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :search="search"
                        :group-by="groupBy.value"
                        @click:row="[$log($event.id)]"
                    >
                        <!-- props for pagination --
                            :server-items-length="totalItems"
                            :options.sync="options"
                            @update:page="paginate($event)"
                            :loading="$root.loading"
                        -->
                        <template v-slot:[`item.info`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <Link
                                        v-if="item.info.user_id"
                                        :href="`/profile/${item.info.user_id}/account`"
                                    >
                                        <v-list-item-title>
                                            {{ item.info.name }}
                                        </v-list-item-title>
                                    </Link>
                                    <v-list-item-title v-else>
                                        {{ item.info.name }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.info.email }}
                                    </v-list-item-subtitle>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.amount`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ formatUnitAmount(item.amount) }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.stripe_fees`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ formatUnitAmount(item.stripe_fees) }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.royalty`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ formatUnitAmount(item.royalty) }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.brand_fund`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ formatUnitAmount(item.brand_fund) }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.sales_tax`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ formatUnitAmount(item.sales_tax) }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.captured`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ formatUnitAmount(item.captured) }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.created`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <small>
                                        {{
                                            globalMomentDateAtTimeDots(
                                                new Date(item.created)
                                            )
                                        }}
                                    </small>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.updated`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <small>
                                        {{
                                            globalMomentDateAtTimeDots(
                                                new Date(item.updated)
                                            )
                                        }}
                                    </small>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`body.append`]="{ items, headers }">
                            <!--<tr>
                                <th class="font-weight-black soli-grey body-2">
                                    Uncollectible:
                                </th>
                                <th
                                    class="soli-grey body-2"
                                    :colspan="headers.length - 1"
                                >
                                    {{ `(${uncollectible.total})` }}
                                </th>
                            </tr>
                            <tr>
                                <th class="font-weight-black soli-grey body-2">
                                    Refunds:
                                </th>
                                <th
                                    class="soli-grey body-2"
                                    :colspan="headers.length - 1"
                                >
                                    {{ `(${uncollectible.total})` }}
                                </th>
                            </tr>-->
                            <tr>
                                <th class="font-weight-black soli-grey body-1">
                                    Totals:
                                </th>
                                <th class="font-weight-black soli-grey body-2">
                                    {{
                                        formatUnitAmount(
                                            items
                                                .map((e) => e.amount)
                                                .reduce((a, b) => a + b)
                                        )
                                    }}
                                </th>
                                <th class="font-weight-black soli-grey body-2">
                                    {{
                                        formatUnitAmount(
                                            items
                                                .map((e) => e.captured)
                                                .reduce((a, b) => a + b)
                                        )
                                    }}
                                </th>
                                <th class="font-weight-black soli-grey body-2">
                                    {{
                                        formatUnitAmount(
                                            items
                                                .map((e) => e.stripe_fees)
                                                .reduce((a, b) => a + b)
                                        )
                                    }}
                                </th>
                                <th class="font-weight-black soli-grey body-2">
                                    {{
                                        formatUnitAmount(
                                            items
                                                .map((e) => e.royalty)
                                                .reduce((a, b) => a + b)
                                        )
                                    }}
                                </th>
                                <th class="font-weight-black soli-grey body-2">
                                    {{
                                        formatUnitAmount(
                                            items
                                                .map((e) => e.brand_fund)
                                                .reduce((a, b) => a + b)
                                        )
                                    }}
                                </th>
                                <th class="font-weight-black soli-grey body-2">
                                    {{
                                        formatUnitAmount(
                                            items
                                                .map((e) => e.sales_tax)
                                                .reduce((a, b) => a + b)
                                        )
                                    }}
                                </th>
                            </tr>
                        </template>
                        <template v-slot:[`item.status`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        <v-chip
                                            small
                                            :class="[
                                                {
                                                    'soli-attendance-green':
                                                        item.status ==
                                                        'Succeeded',
                                                },
                                                {
                                                    'soli-grey':
                                                        item.status ==
                                                        'Pending',
                                                },
                                                {
                                                    'soli-attendance-red':
                                                        item.status ==
                                                        'Uncollectible',
                                                },
                                                {
                                                    dark: item.status.includes(
                                                        'Refund'
                                                    ),
                                                },
                                                'white--text',
                                            ]"
                                        >
                                            {{ item.status }}
                                        </v-chip>
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>
        <SoliResponsiveDialog
            v-if="transactionDetails"
            @reset="closeModal(() => (transactionDetails = null))"
        >
            <template #body> </template
        ></SoliResponsiveDialog>
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import globalMoment from "../../Mixins/GlobalMoment";

export default {
    name: "Transactions",
    props: {
        transactions: {
            type: Array,
            default: () => [],
        },
        selectedLocation: {
            type: Object,
            default: null,
        },
        allLocations: {
            type: Boolean,
            default: false,
        },
        byLocation: {
            type: Boolean,
            default: false,
        },
        rangeStart: {
            type: String,
            default: null,
        },
        /*currentPage: {},
        itemsPerPage: {},
        totalItems: {},*/
    },
    mixins: [globalMoment],
    components: {
        AppLayout,
        Link,
    },
    data() {
        return {
            search: "",
            retryLoading: false,
            showMessage: false,
            groupBy: { display: "Total Transactions", value: null },
            options: {
                page: this.currentPage,
                itemsPerPage: this.itemsPerPage,
            },
            transactionDetails: null,
        };
    },
    computed: {
        headers() {
            if (this.allLocations && !this.byLocation) {
                return [
                    {
                        text: "Location",
                        align: "start",
                        sortable: true,
                        value: "location",
                    },
                    {
                        text: "Transactions",
                        align: "start",
                        sortable: true,
                        value: "total",
                    },
                    {},
                ];
            }
            return [
                {
                    text: "Account",
                    align: "start",
                    sortable: true,
                    value: "info",
                },

                {
                    text: "Amount",
                    align: "start",
                    sortable: true,
                    value: "amount",
                },
                {
                    text: "Captured",
                    align: "start",
                    sortable: true,
                    value: "captured",
                },
                {
                    text: "Stripe Fees",
                    align: "start",
                    sortable: true,
                    value: "stripe_fees",
                },
                {
                    text: "Royalty",
                    align: "start",
                    sortable: true,
                    value: "royalty",
                },
                {
                    text: "Brand Fund",
                    align: "start",
                    sortable: true,
                    value: "brand_fund",
                },
                {
                    text: "Sales Tax",
                    align: "start",
                    sortable: true,
                    value: "sales_tax",
                },
                {
                    text: "Status",
                    align: "start",
                    sortable: true,
                    value: "status",
                },
                {
                    text: "Created",
                    align: "start",
                    sortable: true,
                    value: "created",
                },
                {
                    text: "Updated",
                    align: "start",
                    sortable: true,
                    value: "updated",
                },
            ];
        },
        /*uncollectible() {
            let items = this.transactions.filter(
                (e) => e.status == "Uncollectible"
            );

            return {
                total: this.formatUnitAmount(
                    items.length
                        ? items.map((e) => e.total).reduce((a, b) => a + b)
                        : 0
                ),
            };
        },*/
    },
    methods: {
        setGroupBy(select) {
            if (!select.value) return this.range(0, true, false);
            if (this.byLocation) return null;
            this.range(0, true, true);
        },
        range(adjust, allLocations = false, byLocation = false) {
            this.$inertia.visit(
                `/dashboard/reports/transactions/${moment(
                    new Date(this.rangeStart)
                )
                    .tz("UTC")
                    .add(adjust, "M")
                    .startOf("month")
                    .format("YYYY-MM-DD")}`,
                {
                    data: {
                        allLocations: Number(allLocations),
                        byLocation: Number(byLocation),
                    },
                    preserveState: true,
                }
            );
        },
        /*paginate(page, allLocations = false, byLocation = false) {
            this.$inertia.visit(
                `/dashboard/reports/transactions/${moment(
                    new Date(this.rangeStart)
                )
                    .tz("UTC")
                    .startOf("month")
                    .format("YYYY-MM-DD")}`,
                {
                    data: {
                        allLocations: Number(allLocations),
                        byLocation: Number(byLocation),
                        page: page,
                    },
                    preserveState: true,
                }
            );
        },*/
    },
};
</script>
